import * as React from "react";
import { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import LinkCardSmall from "../LinkCardSmall";
import LoadingCard from "../LoadingCard";
import H from "history";

import ViewSubjectAndYearGroupsImage from "../../images/menu_subjects_and_year_groups.jpg";
import SdsStatusImage from "../../images/menu_sds_status.jpg";
import SchoolPageTitle from "../SchoolPageTitle";

interface SchoolDataMenuPageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
    history: H.History;
}

interface SchoolDataMenuPageState {
    automationEnabled?: boolean;
}

class SchoolDataMenuPage extends Component<SchoolDataMenuPageProps & DispatchProps, SchoolDataMenuPageState> {

    constructor(props: SchoolDataMenuPageProps & DispatchProps) {
        super(props);

        this.state = {
            automationEnabled: undefined
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.checkIfAutomationEnabled();
        }
    }

    async componentDidUpdate(prevProps: Readonly<SchoolDataMenuPageProps & DispatchProps>, prevState: any) {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.checkIfAutomationEnabled();
        }
    }

    async checkIfAutomationEnabled() {
        let automationStatus = await this.props.apiService.getAutomationStatus(this.props.tenantId, this.props.schoolCode);
        let automationEnabled = automationStatus === "Running";
        this.setState({ automationEnabled });

        if (automationEnabled === false) {
            this.props.history.push(this.schoolSubjectDataLink());
        }
    }

    private schoolSubjectDataLink = () => `/manage/${this.props.tenantId}/${this.props.schoolCode}/school-subject-data`;
    private schoolDataLink = () => `/manage/${this.props.tenantId}/${this.props.schoolCode}/school-data`;

    private renderContent() {
        if (this.state.automationEnabled === undefined) {
            return (
                <LoadingCard text="Checking School Data..." />
            )
        }
        else {
            return (
                <div className="help-box help-box--site-type-selection">
                    <LinkCardSmall
                        title="View Subjects and Year Groups"
                        description="See how your subjects and year groups are merged, renamed or excluded."
                        image={ViewSubjectAndYearGroupsImage}
                        href={this.schoolSubjectDataLink()} >
                    </LinkCardSmall>
                    <LinkCardSmall
                        title="SDS Status"
                        description="When did SDS last sync? And what issues with users do I need to look at?"
                        image={SdsStatusImage}
                        href={this.schoolDataLink()} >
                    </LinkCardSmall>
                </div>
            );
        }
    }


    public render(): JSX.Element {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Data Overview" reverse={true} />
                {this.renderContent()}
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): SchoolDataMenuPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(SchoolDataMenuPage)